import React, { useState } from 'react';

import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import Swal from 'sweetalert2';

import { productsData } from 'src/data/productsData';

import WppButton from 'src/components/functional/WppButton';

import FooterCheckout from 'src/components/functional/FooterCheckout';
import CheckoutHeader from 'src/components/functional/HeaderCheckout';
import ChoosePaymentMethod from './Components/ChoosePaymentMethod';
import PurchaseResume from './Components/PurchaseResume';
import PurchaseForms from './Components/PurchaseForms';

import { ICustomerProductData } from '../../interfaces';
import { apiCheckout } from '../../api';

import { CheckoutComponent, ContainerCheckout, ContainerContent } from './style';

import loadingGIF from '../../../../assets/gifs/loading.png';

export default function CheckoutProducts(): JSX.Element {
  const [customerData, setCustomerData] = useState<ICustomerProductData>();
  const [component, setComponent] = useState(0);

  const { token, platform, productName } = useParams();

  const productData = productsData.find(
    (product) => product.routeParam === productName.replaceAll('-', ' ')
  );

  const { isLoading, isError } = useQuery(
    ['getUserInfo', token],
    async () => apiCheckout.getUserProfileInfo(token),
    {
      onError: () => {
        void Swal.fire({
          icon: 'error',
          title: 'Ocorreu um erro ao recuperar os dados!',
          text: 'Por favor, tente novamente mais tarde, ou contate a central.',
          iconColor: 'black',
          confirmButtonColor: 'black',
        });
      },
      onSuccess: (data) => {
        setCustomerData({
          customerName: `${data.firstName} ${data.lastName}`,
          customerEmail: data.email,
          zipCode: data.zipCode,
          customerCpf: '',
          street: '',
          neighborhood: '',
          city: data.city,
          state: data.state,
          streetNumber: '',
          customerPhone: data.phone,
        });

        if (productData.productName === 'Diagnóstico de biotipo' && data.isActive === 1) {
          productData.price = 990;
        }

        if (productData.productName === 'Diagnóstico de estilo' && data.isActive === 1) {
          productData.price = 1990;
        }

        if (productData.productName === '10 Provadores virtuais' && data.isActive === 1) {
          productData.price = 990;
        }

        if (productData.productName === '25 Provadores virtuais' && data.isActive === 1) {
          productData.price = 1990;
        }

        if (productData.productName === '50 Provadores virtuais' && data.isActive === 1) {
          productData.price = 3990;
        }
      },
      refetchOnWindowFocus: false,
    }
  );

  const renderComponent = (): JSX.Element => {
    if (component === 0) {
      return (
        <PurchaseForms
          customerData={customerData}
          setCustomerData={setCustomerData}
          setComponent={setComponent}
        />
      );
    }
    return (
      <ChoosePaymentMethod
        customerData={customerData}
        productData={productData}
        setComponent={setComponent}
        platform={platform}
      />
    );
  };

  return (
    <>
      <ContainerCheckout>
        <CheckoutHeader />
        <ContainerContent>
          <PurchaseResume productData={productData} />
          {isLoading || isError ? (
            <img src={loadingGIF} alt="Loading spinning" width="100" height="100" />
          ) : (
            <CheckoutComponent>{renderComponent()}</CheckoutComponent>
          )}
        </ContainerContent>
        <WppButton />
      </ContainerCheckout>
      <FooterCheckout />
    </>
  );
}
